import * as React from 'react'
import Helmet from 'react-helmet'
import { withConfig } from '../modules/config'


interface Props{
    icon:string,
    config?:any
}


@withConfig
export default class extends React.Component<Props>{
    

    render(){
        const pageTitle = this.props.config.documentTitle;
        const icon = this.props.icon;

        return (
            <Helmet>
                <title>{ pageTitle }</title>
                <link rel="shortcut icon" href={ icon } />
            </Helmet>
        )
    }

}




// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/components/document-header.tsx